module.exports = __webpack_public_path__ + "static/media/common.image.564cccb1.png";